module.exports = __webpack_public_path__ + "static/img/douyin.f83f7d9e.png";